import React, { useEffect, useRef, useState } from 'react'
import './hero.css'
import gsap from 'gsap';
gsap.registerPlugin()
function Hero({ animateText, text2, text1 }) {
    let movingText = useRef(null)
    const [mText, setMText] = useState('individuals')


    useEffect(() => {
        // const textWidget = '.text-reveal h2';
        if (animateText) {
            let chck_if_gsap_loaded = setInterval(function () {
                if (gsap) {
                    text_reveal();
                    clearInterval(chck_if_gsap_loaded);
                }
            }, 3000);


            const text_reveal = () => {
                const changeText = (newtext) => {
                    movingText = newtext
                    setMText(newtext)
                };

                const tl = gsap.timeline({ repeat: -1 });
                tl.call(changeText, ['team']);
                tl.fromTo(movingText, { y: 100 }, { y: 0, ease: 'power3.InOut' }, '<25%');
                tl.to(movingText, { y: -100, ease: 'power3.InOut' }, '+=3');
                tl.call(changeText, ['group']);
                tl.fromTo(movingText, { y: 100 }, { y: 0, ease: 'power3.InOut' }, '<25%');
                tl.to(movingText, { y: -100, ease: 'power3.InOut' }, '+=3');
                tl.call(changeText, ['TechFreelanceX']);
                tl.fromTo(movingText, { y: 100 }, { y: 0, ease: 'power3.InOut' }, '<25%');
                tl.to(movingText, { y: -100, ease: 'power3.InOut' }, '+=3');
                tl.call(changeText, ['individuals']);
                tl.fromTo(movingText, { y: 100 }, { y: 0, ease: 'power3.InOut' }, '<25%');
                tl.to(movingText, { y: -100, ease: 'power3.InOut' }, '+=3');
                
            }
        }


    }, [])


    return (
        <section className='hero'>
            <div className="hero-inner container">
                <div className="line_1">
                    {text1 !== undefined ?
                        <h1>{text1}</h1>
                        :
                        <h1>We are <span ref={(el) => movingText = el} className='moving-text tag_1 '>{mText}</span>
                        </h1>
                    }
                </div>
                <div className="line_2">
                    {text2 !== undefined ?
                        <h1 className='cambon_font'>{text2}</h1>
                        :
                        <h1 className='cambon_font'>exploring new Opportunities .</h1>
                    }

                </div>
            </div>
        </section>
    )
}

export default Hero;